

import {computed, defineComponent, onMounted, ref} from "vue";
import {apiEditCategory, apiGetCategories, Category} from "@/api/categoryApi";
import {useStore} from "vuex";
import {key} from "@/store";
import {ACTIVITY_ID, ATTACHMENTS_ID} from '@/core/constants';


export default defineComponent({
  name: 'QuestionCategory',
  components: {
  },
  setup() {
    const store = useStore(key);
    const newQuestionPositionIndex = computed(() => store.state.createQuestion.questionPositionIndex)
    onMounted(async () => {
      try {
        const categories = await apiGetCategories();
        updateCategoriesInStore(categories);
        if(newQuestionPositionIndex.value === null) { // wouldn't choose default category in case it's going back from create question page
          setInitialCurrentCategory(categories);
        }
      } catch (e) {
        throw new Error('Failing Getting categories');
      }
    })

    const updateCategoriesInStore = (categories: Category[]) => {
      store.commit('setCategories', categories);
    }

    const setInitialCurrentCategory = (categories: Category[]) => {
      store.commit('setCurrentCategory', categories[0].id);
    }

    const categories = computed((): Category[] => store.state.categories)
    const currentCategory = computed(() => store.state.currentCategory);
    const isEditingCategory = computed(() => store.state.isEditingCategory);

    const openCategory = (categoryId: number | null) => {
       if(isEditingCategory.value) {
         return ;
       }
      window.scrollTo(0,0);
      store.commit('setCurrentCategory', categoryId);
    }



    const openActivity = () => {
      openCategory(ACTIVITY_ID);
    }

    const openAttachments = () => {
      openCategory(ATTACHMENTS_ID);
    }

    return {
      categories,
      currentCategory,
      isEditingCategory,
      openCategory,
      store,
      openActivity,
      ACTIVITY_ID,
      openAttachments,
      ATTACHMENTS_ID,
    }
  }
})
